import script from "./DigitalmanSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./DigitalmanSettings.vue?vue&type=script&setup=true&lang=ts"

import "./DigitalmanSettings.vue?vue&type=style&index=0&id=7445128e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7445128e"]])

export default __exports__